<template>
  <div class="d-flex flex-column">
    <div class="filter-component-container d-flex align-center flex-fill mb-2">
      <!-- <div class="d-flex flex-column justify-content-center mr-2 m-basis-40">
        <span class="font-inter titulo-5"> 
          Evaluación
        </span>          
        <v-text-field
            dense
            name="nombre"
            placeholder="Evaluación"
            outlined
            hide-details="auto"
            v-model="filter.nombre"
          ></v-text-field>
      </div>

      <div class="d-flex flex-column justify-content-center mr-2 m-basis-40">
        <span class="font-inter titulo-5"> 
          Código
        </span>   
        <v-text-field
          dense
          name="codigo"
          placeholder="Codigo"
          outlined
          hide-details="auto"
          v-model="filter.codigo"
        ></v-text-field>
      </div> -->
      <div class="d-flex flex-column justify-content-center mr-2 m-basis-40">
        <span class="font-inter titulo-5"> 
          Asignatura
        </span>   
        <v-select
          :items="user().subjects"
          name="idAsignatura"
          v-model="filter.idAsignatura"
          dense
          outlined
          hide-details="auto"
          placeholder="Asignatura"
          :item-text="item => item.name"
          :item-value="item => item.subjectId"
        ></v-select>
      </div>

      <div class="d-flex flex-column justify-content-center m-basis-40">
        <span class="font-inter titulo-5"> 
          Estado
        </span>   
        <v-select
          :items="estado"
          name="idEstado"
          v-model="filter.idEstado"
          dense
          multiple
          outlined
          hide-details="auto"
          placeholder="Estado"
        ></v-select>
      </div>

       <div class="ml-2 mt-auto m-basis-90 d-flex justify-content-end">
        <v-btn dark class="primary-btn text-capitalize text-center" @click="handleFilterEvaluations()" height='40px'>
          <v-icon> mdi-magnify </v-icon>
          <span class="hide-sm">Buscar</span>
        </v-btn>
      </div>
    </div>
  </div>
  
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// import EvaluationSortFilter from "@/components/evaluations/EvaluationSortFilter";

const initialFilter = {
  codigo: "",
  nombre: "",
  idAsignatura: "",
};

export default {
  components: {
        // EvaluationSortFilter
    },
  data() {
    return {
      filter: {
        codigo: "",
        nombre: "",
        idAsignatura: "",
        idEstado: [0,1]
      },

      searchText: "",
      showFilter: false,
      subjects: [],
      estado: [
        // {text:"SIN FILTRO",value:""},
        {text:"PENDIENTE",value:0},
        {text:"EN PROCESO",value:1},
        //{text:"COMPLETA",value:2},
        //{text:"EVALUADA",value:3}
      ],
    };
  },
  methods: {
    ...mapGetters({
      lessonFilter: "getLessonFilterInformation",
      user: "getUserData"
    }),
    showFilterModal() {
      this.showFilter = !this.showFilter;
    },
    hideFilter() {
      this.showFilter = false;
    },
    search() {
      console.info("--Searching--");
      console.log(this.filter);
    },
    ...mapActions({
      filterEvaluations: "filterEvaluations",
    }),
    handleFilterEvaluations() {
      const { personId, section, institutionContext } = this.user();
      this.filter.idPersona = personId,
      this.filter.idPeriodo = institutionContext.periodId,

      // TO-DO:comunnicate with the cards to restart the currentPage 
      this.filter.pageNumber =  0 

      this.filterEvaluations(this.filter);
      // Object.assign(this.$data.filter, initialFilter);
      // this.showFilter = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/generals.scss';

.v-input__slot {
  margin-bottom: 0px !important;
}
.filter-btn.filter-btn {
  box-shadow: 0px 6px 15px #00000029;
  height: 65px !important;
  min-width: 161px !important;
  border-radius: 33px !important;
  span {
    font-size: 18px;
    margin: 0 10px;
  }
  .v-icon {
    font-size: 32px;
  }
}

</style>
